import * as PropTypes from 'prop-types';
import React, {useContext, useEffect, useState} from "react";
import { buyNowContext } from "../BuyNow";
import PromoAmount from "./PromoAmount";
import {PROMO_TYPES} from "../../utils/promoCode";
import { applyPromoCode } from "../../utils/pricingHelper";
import {PRODUCT_CATEGORIES} from "../../../../constants";

const PromoCode = ({ disableEntry, hideDecimalIfWhole, className, specialButtonColor }) => {
  const { lineItems, purchaseFlow, promoCode, setPromoCode, PURCHASE_STAGES, purchaseStage, promotional, urlPromoCode, referralCode, removeLineItems } = useContext(buyNowContext);

  const [promoCodeText, setPromoCodeText] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const apply = (promoCodeTextOverride, displayErrors = true, referralCode = null) => {
    setErrorMessage(null);
    applyPromoCode(promoCodeTextOverride || promoCodeText, purchaseFlow, lineItems, referralCode)
      .then(validPromoCode => {
        if (validPromoCode.hasLicenseKey) {
          const planLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MEMBERSHIP);
          if (planLineItem)
            removeLineItems(planLineItem);
        }

        setPromoCode(validPromoCode);
      })
      .catch(error => {
        if (displayErrors) {
          setErrorMessage(error);
          setPromoCode(null);
        }
      });
  };

  useEffect(() => {
    // A referral code takes precedence over anything. Users get a discount when using a referral code via a special promo code.
    if (referralCode)
      apply('REFERRAL_CODE_DISCOUNT', false, referralCode);
    // Per conversation with Clayton, a promo code in the URL query string takes precedence over an active promotion.
    else if (urlPromoCode)
      apply(urlPromoCode, false);
    else if (promotional && purchaseFlow === promotional.purchaseFlow)
      apply(promotional.promoCode.code, false);
  }, [lineItems]);

  // Render nothing if there are no line items.
  if (!lineItems.length)
    return null;

  // If the user hasn't entered a promo code yet, and we have disabled the entry of a promo code, render nothing.
  if (!promoCode && disableEntry)
    return null;

  const scrollTop = ()=> {
    if(purchaseStage !== PURCHASE_STAGES.PRODUCT_SELECTION)
    {
      window.scrollTo(0, 0)
    }
  };

  const promoCodeAppliedMessage = promoCode && promoCode.appliedMessage && promoCode.appliedMessage.trim().length > 0 ? promoCode.appliedMessage : "Promo code applied!";

  return (
    <section>
      <div className={`row mb-3 mx-auto ${className}`}>
        {promoCode ?
          purchaseStage === PURCHASE_STAGES.PRODUCT_SELECTION ?
            <div className="w-100" style={{ paddingLeft: 0, paddingRight: 0 }}>
              <span className="font-italic fw-bold" style={{ fontSize: "16px", color: "red" }}>
                {promoCodeAppliedMessage}
              </span>
            </div>
            :
            <div className="col">
              <div className="row">
                <div className="col-9 d-flex flex-column p-0">
                  <p className="plan-main-txt text-dark mb-0 pb-0 fw-bolder">Promo code</p>
                  <p className="sub-txt text-muted pb-0">{promoCode.promoCodeText}</p>
                </div>
                <div className="col-3 text-end p-0">
               <span className="plan-main-txt fw-bolder float-end" style={{ color: "red" }}>
                 { // For a 'sub delay' promo type, we'll show a generic "Applied!" message since this produces no monetary discount, just extra free days for your subscription.
                   promoCode.promoType === PROMO_TYPES.SUB_DELAY ?
                   "Applied!"
                 :
                   <React.Fragment>- $<PromoAmount hideDecimalIfWhole={hideDecimalIfWhole} /></React.Fragment>
                 }
               </span>
                </div>
              </div>
            </div>
          :
          <React.Fragment>
            <div className="col-10 px-0">
              <input
                onBlur={scrollTop}
                type="text"
                className="form-control d-inline promo-code-text-input"
                id="inlineFormPromoCode"
                placeholder="Enter promo code"
                value={promoCodeText}
                onChange={event => setPromoCodeText(event.target.value)}
              />
            </div>
            <button
              type="button"
              className="d-inline teal-background rounded-end col-2 promo-apply-btn-txt border-start-0 border-end-0 px-0"
              style={{background: specialButtonColor, borderColor: specialButtonColor}}
              onClick={() => apply()}
            >
              Apply
            </button>
            {errorMessage &&
            <p className="text-danger plan-main-txt mt-1">
              {errorMessage}
            </p>
            }
          </React.Fragment>
        }
      </div>
    </section>
  );
};

PromoCode.propTypes = {
  disableEntry: PropTypes.bool,
  hideDecimalIfWhole: PropTypes.bool,
  className: PropTypes.string
};

PromoCode.defaultProps = {
  disableEntry: false,
  hideDecimalIfWhole: true,
  className: ""
};

export default PromoCode;
